import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewSteps: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTradingViewSteps"><Path fillRule="evenodd" clipRule="evenodd" d="M10.5 3V13H8.5V3H10.5ZM5 7V17H3V7H5ZM21 7V17H19V7H21ZM15.5 11V21H13.5V11H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTradingViewSteps;
